import { SvgIcon, SvgIconProps } from '@mui/material';

export const VerificationCodeLock = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 164 164'
    >
      <circle
        cx='82'
        cy='81.5'
        r='81.5'
        fill='#F0F5FF'
      />
      <rect
        x='53.1641'
        y='32.8984'
        width='57.6758'
        height='71.3268'
        rx='28.8379'
        fill='#1F477D'
      />
      <rect
        x='61.0156'
        y='41.0859'
        width='42.3183'
        height='54.9456'
        rx='21.1592'
        fill='#F0F5FF'
      />
      <rect
        x='41.3789'
        y='76.4062'
        width='81.2477'
        height='54.2868'
        rx='7.5'
        fill='#3E8FFA'
        stroke='#3E8FFA'
      />
      <path
        d='M76.0312 116.327L78.4202 98.9219H85.587L88.4879 116.327H76.0312Z'
        fill='white'
      />
      <ellipse
        cx='82.004'
        cy='95.6824'
        rx='6.99617'
        ry='7.16681'
        fill='white'
      />
    </SvgIcon>
  );
};
